class EmailService {
  async sendApplicationApproval(application) {
    try {
      const response = await fetch('/api/email/application-approval', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          applicationId: application._id,
          projectName: application.project.name,
          applicantEmail: application.applicant.email,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send approval email');
      }

      return await response.json();
    } catch (error) {
      console.error('Error sending approval email:', error);
      throw error;
    }
  }

  async sendApplicationDenial(application, reason) {
    try {
      const response = await fetch('/api/email/application-denial', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          applicationId: application._id,
          projectName: application.project.name,
          applicantEmail: application.applicant.email,
          reason,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send denial email');
      }

      return await response.json();
    } catch (error) {
      console.error('Error sending denial email:', error);
      throw error;
    }
  }

  async sendInfoRequest(application, details) {
    try {
      const response = await fetch('/api/email/info-request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          applicationId: application._id,
          projectName: application.project.name,
          applicantEmail: application.applicant.email,
          details,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send info request email');
      }

      return await response.json();
    } catch (error) {
      console.error('Error sending info request email:', error);
      throw error;
    }
  }

  async sendMeetingConfirmation(application, meetingDetails) {
    try {
      const response = await fetch('/api/email/meeting-confirmation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          applicationId: application._id,
          projectName: application.project.name,
          applicantEmail: application.applicant.email,
          meetingDetails,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send meeting confirmation');
      }

      return await response.json();
    } catch (error) {
      console.error('Error sending meeting confirmation:', error);
      throw error;
    }
  }
}

export default new EmailService(); 